module.exports = __webpack_public_path__ + "img/1.c03e19b1.png";